<script setup lang="ts">
import { ShieldCheck, Award, GraduationCap } from 'lucide-vue-next'

interface Badge {
  icon: 'shield' | 'award' | 'graduation'
  title: string
  description: string
  color: 'green' | 'blue' | 'purple'
}

interface Props {
  badges?: Badge[]
}

const props = withDefaults(defineProps<Props>(), {
  badges: () => [
    { icon: 'shield', title: 'Verified Tutor', description: 'Background checked', color: 'green' },
    { icon: 'award', title: 'Top Rated', description: 'In top 5% of tutors', color: 'blue' },
    { icon: 'graduation', title: 'Qualified Teacher', description: 'QTS certified', color: 'purple' }
  ]
})

const iconComponents = {
  shield: ShieldCheck,
  award: Award,
  graduation: GraduationCap
}

const colorClasses = {
  green: {
    bg: 'bg-green-100',
    text: 'text-green-600'
  },
  blue: {
    bg: 'bg-blue-100',
    text: 'text-blue-600'
  },
  purple: {
    bg: 'bg-purple-100',
    text: 'text-purple-600'
  }
}
</script>

<template>
  <section class="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6">
    <div class="space-y-4">
      <div
        v-for="(badge, index) in badges"
        :key="index"
        class="flex items-center gap-3"
      >
        <div
          :class="[
            'w-10 h-10 rounded-lg flex items-center justify-center',
            colorClasses[badge.color].bg
          ]"
        >
          <component
            :is="iconComponents[badge.icon]"
            :class="['w-5 h-5', colorClasses[badge.color].text]"
          />
        </div>
        <div>
          <p class="font-medium text-gray-900 text-sm">{{ badge.title }}</p>
          <p class="text-xs text-gray-600">{{ badge.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
